import { components } from 'react-select';

export function MenuListWithoutSelectAll(props) {
  return <components.MenuList {...props} />;
}
